import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import Logo from '../../components/settings/modals/Logo';
import ClinicInfo from '../../components/settings/modals/ClinicInfo';
import OfficeSwitcher from '../../components/settings/modals/OfficeSwitcher';
import ProfileInfo from '../../components/settings/modals/ProfileInfo';
import Signature from '../../components/settings/modals/Signature';

const SettingsPage = () => {

    return (
        <>
            <Typography variant="h4">Settings</Typography>
            <List>
                <ProfileInfo />
                <Signature />
                <ClinicInfo />
                <Logo />
                <OfficeSwitcher />
            </List>
        </>
    );
};

export default SettingsPage;
